<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="lifes-dreams">
<h1>Life’s Dreams</h1>
<p style="text-indent:0em">Years have come and gone,</p>
<p style="text-indent:0em">and left me old and gray.</p>
<p style="text-indent:0em">Alone in my thoughts,</p>
<p style="text-indent:0em">each and every day.</p><br/>
<p style="text-indent:0em">My life is but a dream,</p>
<p style="text-indent:0em">the dreams of yesterday.</p>
<p style="text-indent:0em">The dreams of gaiety and youth,</p>
<p style="text-indent:0em">when we were young forever yesterday.</p><br/>
<p style="text-indent:0em">She left me with tears and sorrow,</p>
<p style="text-indent:0em">as life is funny that way.</p>
<p style="text-indent:0em">The Mona Lisa smile,</p>
<p style="text-indent:0em">I dream of each and every day.</p><br/>
<p style="text-indent:0em">Life of dreams together,</p>
<p style="text-indent:0em">hearts full of love.</p>
<p style="text-indent:0em">The tenderness of her kiss,</p>
<p style="text-indent:0em">were dreams of yesterday’s wish.</p><br/>
<p style="text-indent:0em">The days go by are long and blue,</p>
<p style="text-indent:0em">nights are sadness too.</p>
<p style="text-indent:0em">Father time cannot erase,</p>
<p style="text-indent:0em">my love for you.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?48a82dc2